import React from 'react';
import styled from 'styled-components';
import { Body5, Body7, Container } from '@ui';
import { CopyButton, TransparentFlatButton } from '@ui/buttons';

const RevealWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
  border-radius: 6px;
  padding: 16px;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
`;
const SecretWrapper = styled.div`
  font-family: monospace;
  font-size: 13px;
  word-break: break-all;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  background: ${({ theme }) => theme.themeColors.appBackground};
  color: ${({ theme }) => theme.themeColors.text};
`;
const WarningText = styled(Body5)`
  color: ${({ theme }) => theme.themeColors.error};
`;

// Surfaces the freshly created secret EXACTLY ONCE -- the API never returns it
// again. Persists until the user explicitly dismisses it (no auto-hide), so the
// secret can't scroll out of reach before it's copied.
export const ApiKeyRevealBox = ({ apiKey, onDismiss }) => {
  if (!apiKey) return null;

  return (
    <RevealWrapper>
      <Body5 bold>API key created: {apiKey.name}</Body5>
      <Container top={12}>
        <SecretWrapper>{apiKey.api_key}</SecretWrapper>
      </Container>
      <Container top={12} row verticallyCenter spaceBetween>
        <CopyButton text={apiKey.api_key} />
        <TransparentFlatButton onClick={onDismiss}>Dismiss</TransparentFlatButton>
      </Container>
      <Container top={12}>
        <WarningText bold>
          Copy this key now. For security, you won't be able to see it again.
        </WarningText>
      </Container>
      <Container top={4}>
        <Body7 isLowContrast>
          Use it as a bearer token: <code>Authorization: Bearer {apiKey.prefix}…</code>
        </Body7>
      </Container>
    </RevealWrapper>
  );
};
